'use client';

import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { useTranslation } from '@/translations';
import { ShopHeroProps } from './types';

export const ShopHero: React.FC<ShopHeroProps> = ({ title, subtitle }) => {
  const { language } = useLanguage();
  const t = useTranslation(language);

  return (
    <section
      className="organic relative overflow-hidden"
      style={{
        padding: 'calc(64px + var(--space-8) * 1.6) clamp(20px, 4vw, 48px) var(--space-8)',
      }}
    >
      <div
        aria-hidden="true"
        className="absolute rounded-full"
        style={{
          right: -120,
          top: -140,
          width: 300,
          height: 300,
          background: 'var(--color-accent-2-200)',
          zIndex: 0,
        }}
      />
      <div className="max-w-7xl mx-auto relative" style={{ zIndex: 1, maxWidth: 640 }}>
        <span
          className="block uppercase mb-2"
          style={{
            fontSize: 13,
            letterSpacing: '0.06em',
            fontWeight: 600,
            color: 'var(--color-accent-700)',
          }}
        >
          {t('shop.title')}
        </span>
        <h1
          className="mb-3"
          style={{ fontSize: 'clamp(34px, 4.4vw, 54px)', lineHeight: 1.08, margin: '0 0 var(--space-3)' }}
        >
          {title}
        </h1>
        <p
          style={{
            fontSize: 16.5,
            lineHeight: 1.6,
            color: 'color-mix(in srgb, var(--color-text) 78%, transparent)',
            maxWidth: '52ch',
            margin: 0,
          }}
        >
          {subtitle}
        </p>
      </div>
    </section>
  );
};
